<template>
  <div class="scroll-coupon-list">
    <div class="opacity-bar"></div>
    <soda-coupon-cell class="coupon-cell" v-for="(coupon, index) in couponData.couponList" 
      :key="index" 
      :index="index" 
      backgroundColor="#fff"
      :couponSrc="coupon"
      :country="country">
    </soda-coupon-cell>
  </div>
</template>

<script>

export default {
  name: 'scroll-coupon',
  data () {
    return {
      scrollOptions: {
        click: true,
        bounce: {
          top: false,
          bottom: false,
          left: true,
          right: true
        },
        pullUpLoad: false
      },
      scrollEvents: ['scroll']
    }
  },
  props: ['couponData'],
  computed: {
    country () {
      return this.$store.state.country
    }
  }
}
</script>

<style lang="stylus">
@import "~@/common/stylus/variables"
.scroll-coupon-list {
  position relative
  padding 0 4px
  padding-top 50px
  margin-bottom 50px
  overflow visible
  .opacity-bar {
    position absolute
    top -20px
    left 0
    width 100%
    height 50px
    background-color $color-white
    box-shadow 0 10px 20px 10px $color-white
    z-index 9
  }
  // 重写rich-scroll样式
  .rich-scroll-wrapper {
    overflow visible
    .rich-scroll-list-wrapper {
      overflow visible
    }
  }
  .coupon-cell{
    margin-bottom:14px;
    box-shadow: 0 0px 2px #ddd;
    width:calc(100vw - 80px)
  }
}
</style>
